import React from 'react';

import {useTranslation} from "react-i18next";

import Alert from "@mui/material/Alert";

import PageLayout from "../../layout/PageLayout";

const PageNotFound = () => {
    const { t } = useTranslation("common");

    return (
        <PageLayout>
            <Alert severity="error">{t("page_not_found")}</Alert>
        </PageLayout>
    );
};

export default PageNotFound;